import Button from "@/components/Button";

export default function WizardCTA({ title }) {
  return (
    <section className="mt-20">
      <div className="rounded-[2.5rem] bg-[#F2F6FF] px-6 py-12 ring-1 ring-slate-200/70 sm:px-10">
        <div className="flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center">
          <div>
            <h2 className="text-2xl font-semibold tracking-tight sm:text-3xl">
              {title || "Unsicher, welche Fotobox zu deinem Event passt?"}
            </h2>
            <p className="mt-2 text-sm leading-6 text-slate-600 sm:text-base">
              Kurze einfache Fragen beantworten und direkt passende Anbieter
              entdecken.
            </p>
          </div>
          <Button
            href="/fotobox-finder"
            variant="primary"
            noFollow
            noOpener
            postToHrefOnSeo
          >
            Fotobox-Finder
          </Button>
        </div>
      </div>
    </section>
  );
}
